/* ============================================================================
FILE: po-katupirsia5-enneagone-texts-fr-en-es-20260303.js
MODE: JS FR/EN/ES (injection tri) + lexicon override (termes FR) si présent
API:  window.PoKatupirsia5EnneagoneTextsFR_EN_ES_20260303
ROOT: .po-axis-section[data-po-axis][data-po-lex-id="enneagone"]

ROLE:
  - Injecte le contenu FR/EN/ES dans les slots selon la langue choisie (localStorage).
  - Lang storage:
      - clé principale : po_lex_lang
      - clé compat :     goody_gp_lang
    Langues autorisées : fr, en, es.
  - Expose getLang(), setLang(lang), init() et stopAudio() ; déclenche po:locale-changed après bascule.
  - Écoute po:lexicon-ready pour re-render si le lexique arrive après.
  - Protection fine PRIORITAIRE : verrouille (translate="no") TOUTES les occurrences du lexique simplifié
    FR canonique via meta.lexique_simplifie_fr (si dispo), variantes apostrophes + œ/oe,
    + anti-collage (espaces DOM uniquement quand nécessaire).
  - IMPORTANT : les entrées lexicales canoniques restent en FR quelle que soit la langue affichée.
  - Ajoute une couche audio générale + audio locale par bloc, sans casser le socle existant.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_K5_ENNEAGONE_TEXTS_20260303__) return;
  window.__PO_K5_ENNEAGONE_TEXTS_20260303__ = true;

  var STORAGE_KEY = 'po_lex_lang';
  var STORAGE_KEY_COMPAT = 'goody_gp_lang';
  var ROOT_SEL = '.po-axis-section[data-po-axis]';
  var TARGET_ID = 'enneagone';

  var IMG_IDEOGRAM_CONCEPT = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Enneagone_copie.png?v=1772894801';
  var IMG_FUNCTION = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Enneagonne_regulateur_fonctionnel.png?v=1773289356';
  var IMG_FREQ_145 = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_145.png?v=1773413772';
  var IMG_ISQUN = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/L_Isqun_copie.png?v=1772883682';

  var CANON = {
    title: 'Ennéagone régulateur',
    page_terms: [
      'Ennéagone', 'Ennéagone régulateur', 'Isqun', 'Threnisqun', 'La Katûvýs', 'Katûvýs',
      'RéZonans', 'Organon', 'Sceau d’Équiphase', 'Sceau de Syntonie', 'Sceau d’Aísthisi',
      'Sceau d’Anépôron', 'Sceau d’Ifẹ̀', 'Sceau d’Ayeẹmí', 'Sceau d’Ọ̀rọ̀yuyay',
      'Sceau de Yuyarina', 'Sceau d’Œndomare', 'Êkhö', 'nombre-guide'
    ]
  };

  function clampStr(v){ return (v == null) ? '' : String(v); }
  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, '-');
    if (s.indexOf('fr') === 0) return 'fr';
    if (s.indexOf('en') === 0) return 'en';
    if (s.indexOf('es') === 0) return 'es';
    if (s.indexOf('pt') === 0) return 'es';
    return '';
  }

  function readStoredLang(){
    try{ var v = normLang(localStorage.getItem(STORAGE_KEY) || ''); if (v) return v; }catch(e){}
    try{ var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT) || ''); if (v2) return v2; }catch(e){}
    return '';
  }

  var __PO_HTML_LANG_SYNC__ = false;

  function storeLang(lang){
    var v = normLang(lang) || 'fr';
    try{ localStorage.setItem(STORAGE_KEY, v); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, v); }catch(e){}
    try{
      if (document && document.documentElement){
        var currentLang = normLang(document.documentElement.getAttribute('lang') || '') || '';
        if (currentLang !== v){
          __PO_HTML_LANG_SYNC__ = true;
          document.documentElement.setAttribute('lang', v);
          setTimeout(function(){ __PO_HTML_LANG_SYNC__ = false; }, 0);
        }
      }
    }catch(e){ __PO_HTML_LANG_SYNC__ = false; }
    return v;
  }

  function detectBrowserLang(){
    try{
      var dl = (document && document.documentElement) ? (document.documentElement.getAttribute('lang') || '') : '';
      var dln = normLang(dl);
      if (dln) return dln;
    }catch(e){}
    try{
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || '';
      var v = normLang(n);
      if (v) return v;
    }catch(e){}
    return 'fr';
  }

  function getLang(){ return readStoredLang() || detectBrowserLang() || 'fr'; }

  function notifyLocaleChanged(){
    try{ window.dispatchEvent(new Event('po:locale-changed')); }
    catch(e){
      try{ var ev = document.createEvent('Event'); ev.initEvent('po:locale-changed', true, true); window.dispatchEvent(ev); }catch(_e){}
    }
  }

  function getTargetBlocks(){
    var nodes = [];
    try{
      var all = document.querySelectorAll(ROOT_SEL);
      for (var i=0;i<all.length;i++){
        var id = '';
        try{ id = all[i].getAttribute('data-po-lex-id') || ''; }catch(e){ id = ''; }
        if (id === TARGET_ID) nodes.push(all[i]);
      }
    }catch(e){}
    return nodes;
  }

  function getLexiconEntry(id){
    try{ if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id]; }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++) if (arr[i] && arr[i].id === id) return arr[i];
      }
    }catch(e){}
    return null;
  }

  function pickAny(entry, key, fallback){ try{ if (entry && entry[key] != null) return entry[key]; }catch(e){} return fallback; }
  function pickDefShort(entry, lang){ if (!entry) return ''; try{ return clampStr(entry['definition_short_' + lang] || entry['definition_' + lang] || ''); }catch(e){} return ''; }
  function pickDefLong(entry, lang){ if (!entry) return ''; try{ return clampStr(entry['definition_long_' + lang] || entry['definition_' + lang] || ''); }catch(e){} return ''; }
  function pickArray(entry, lang, base){ if (!entry) return []; try{ var v = entry[base + '_' + lang]; if (Array.isArray(v)) return v; }catch(e){} return []; }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/\"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }
  function escapeRegExp(s){ return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function uniqPush(arr, v, seen){ var k = clampStr(v); if (!k || seen[k]) return; seen[k] = true; arr.push(k); }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;
    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, '’'), seen);
    uniqPush(out, t.replace(/œ/g, 'oe').replace(/Œ/g, 'OE'), seen);
    uniqPush(out, t.replace(/oe/g, 'œ').replace(/OE/g, 'Œ'), seen);
    var oe1 = t.replace(/œ/g, 'oe').replace(/Œ/g, 'OE');
    var oe2 = t.replace(/oe/g, 'œ').replace(/OE/g, 'Œ');
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, '’'), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, '’'), seen);
    return out;
  }

  function getSimplifiedLexiqueFRList(){
    var out = [];
    var seen = Object.create(null);
    function addMany(arr){ if (!Array.isArray(arr)) return; for (var i=0;i<arr.length;i++) uniqPush(out, arr[i], seen); }
    try{ if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) addMany(window.PO_LEXICON_META.lexique_simplifie_fr); }catch(e){}
    try{ if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) addMany(window.PO_LEXICON.meta.lexique_simplifie_fr); }catch(e){}
    addMany(CANON.page_terms);
    return out;
  }

  var __PO_PROTECT_CACHE__ = { key:'', re:null };
  function buildProtectMatcher(){
    var base = getSimplifiedLexiqueFRList();
    var variants = [], seen = Object.create(null);
    for (var i=0;i<base.length;i++){
      var list = buildVariants(base[i]);
      for (var j=0;j<list.length;j++) uniqPush(variants, list[j], seen);
    }
    variants.sort(function(a,b){ return b.length - a.length; });
    var parts = [];
    for (var k=0;k<variants.length;k++) parts.push(escapeRegExp(variants[k]));
    if (!parts.length) return null;
    try{ return new RegExp('(' + parts.join('|') + ')', 'g'); }catch(e){ return null; }
  }

  function ensureProtectEngineReady(){
    var key = 'meta:none';
    try{ var l = getSimplifiedLexiqueFRList(); key = 'meta:' + (l ? l.length : 0); }catch(e){ key = 'meta:none'; }
    if (__PO_PROTECT_CACHE__.key === key) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectMatcher();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute('translate');
    if (tr && String(tr).toLowerCase() === 'no') return true;
    var cls = el.className || '';
    if (typeof cls === 'string'){
      if (cls.indexOf('notranslate') !== -1) return true;
      if (cls.indexOf('po-lex-protect') !== -1) return true;
      if (cls.indexOf('po-axis-audio-wrap') !== -1) return true;
      if (cls.indexOf('po-axis-audio-btn') !== -1) return true;
    }
    return false;
  }
  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){ if (isLockedElement(el)) return true; el = el.parentElement; }
    return false;
  }
  function isWordLikeChar(ch){ return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch || ''); }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;
    var txt = textNode.nodeValue;
    if (!txt) return;
    re.lastIndex = 0;
    if (!re.test(txt)) return;
    re.lastIndex = 0;

    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;
    while ((m = re.exec(txt)) !== null){
      var start = m.index, hit = m[0], end = start + hit.length;
      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));
      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : '';
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(' '));
      var span = doc.createElement('span');
      span.setAttribute('translate', 'no');
      span.className = 'po-lex-protect notranslate';
      span.textContent = hit;
      frag.appendChild(span);
      var chNext = (end < txt.length) ? txt.charAt(end) : '';
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(' '));
      last = end;
      if (hit.length === 0) break;
    }
    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;
    var walker;
    try{
      walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
        acceptNode: function(n){
          if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
          if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
          var p = n.parentNode;
          var pn = p && p.nodeName ? p.nodeName : '';
          if (pn === 'SCRIPT' || pn === 'STYLE') return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      }, false);
    }catch(e){ return; }
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
  }

  function protectKeywordsHTML(html){
    var s = clampStr(html);
    if (!s) return '';
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return s;
    var tpl = document.createElement('template');
    tpl.innerHTML = s;
    var root = tpl.content || tpl;
    var walker;
    try{
      walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function(n){ if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT; if (isLockedNode(n)) return NodeFilter.FILTER_REJECT; return NodeFilter.FILTER_ACCEPT; }
      }, false);
    }catch(e){ return s; }
    var nodes = [], t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){ var s = clampStr(txt); if (!s) return ''; return '<p>' + escapeHTML(s).replace(/\n+/g, '</p><p>') + '</p>'; }

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:'', speaking:false, utterance:null };
  var AUDIO_UI = {
    fr: { general:'Écouter le texte', block:'Écouter ce bloc', stop:'Arrêter la lecture' },
    en: { general:'Listen to the text', block:'Listen to this section', stop:'Stop playback' },
    es: { general:'Escuchar el texto', block:'Escuchar este bloque', stop:'Detener la lectura' }
  };
  function audioUI(lang){ var L = normLang(lang) || 'fr'; return AUDIO_UI[L] || AUDIO_UI.fr; }

  function ensureAudioStyles(){
    if (document.getElementById('po-axis-audio-styles-enneagone-20260303')) return;
    var st = document.createElement('style');
    st.id = 'po-axis-audio-styles-enneagone-20260303';
    st.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;margin:10px 0 12px;}',
      '.po-axis-audio-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;border:1px solid rgba(184,134,11,.45);border-radius:999px;padding:8px 12px;background:rgba(0,0,0,.02);font:inherit;font-weight:800;letter-spacing:.2px;cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;box-shadow:0 0 0 1px rgba(184,134,11,.12),0 8px 18px rgba(31,122,58,.10);}',
      '.po-axis-audio-btn:hover{box-shadow:0 0 0 1px rgba(184,134,11,.24),0 10px 24px rgba(31,122,58,.14);}',
      '.po-axis-audio-btn.is-active{border-color:rgba(31,122,58,.55);box-shadow:0 0 0 1px rgba(31,122,58,.20),0 12px 28px rgba(31,122,58,.18);}',
      '.po-axis-audio-btn__label{color:var(--color-accent,#1f7a3a);}',
      '.po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;padding:6px 10px;font-size:12px;}',
      '.po-lex-summary .po-axis-audio-btn__label{white-space:nowrap;}',
      '@media (max-width:760px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{order:3;width:100%;justify-content:center;margin-top:8px;}}'
    ].join('');
    document.head.appendChild(st);
  }

  function createAudioButton(role, index){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role);
    if (index != null) btn.setAttribute('data-po-audio-index', String(index));
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = '<span class="po-axis-audio-btn__label"></span>';
    return btn;
  }
  function getAudioButtonLabel(role, lang, isActive){ var ui = audioUI(lang); if (isActive) return ui.stop; return role === 'general' ? ui.general : ui.block; }
  function updateAudioButtonLabel(btn, lang, isActive){ if (!btn) return; var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block'); var label = btn.querySelector('.po-axis-audio-btn__label') || btn; label.textContent = getAudioButtonLabel(role, lang, !!isActive); btn.setAttribute('aria-pressed', isActive ? 'true' : 'false'); if (isActive) btn.classList.add('is-active'); else btn.classList.remove('is-active'); }
  function updateAudioButtonsState(root, lang){ if (!root) return; var btns = root.querySelectorAll('.po-axis-audio-btn[data-po-audio-role]'); var activeKey = (PO_AUDIO_STATE.root === root) ? PO_AUDIO_STATE.activeKey : ''; for (var i=0;i<btns.length;i++){ var btn = btns[i]; var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block'); var idx = clampStr(btn.getAttribute('data-po-audio-index') || ''); var key = (role === 'general') ? 'general' : ('block-' + idx); updateAudioButtonLabel(btn, lang, key && key === activeKey && PO_AUDIO_STATE.speaking); } }

  function stopAudio(resetButtons){
    try{ if (PO_AUDIO_SYNTH) PO_AUDIO_SYNTH.cancel(); }catch(e){}
    PO_AUDIO_STATE.root = null; PO_AUDIO_STATE.units = []; PO_AUDIO_STATE.unitPos = -1; PO_AUDIO_STATE.chunks = []; PO_AUDIO_STATE.chunkPos = -1; PO_AUDIO_STATE.activeKey = ''; PO_AUDIO_STATE.speaking = false; PO_AUDIO_STATE.utterance = null;
    if (resetButtons !== false){ var roots = getTargetBlocks(); for (var i=0;i<roots.length;i++) updateAudioButtonsState(roots[i], getLang()); }
  }

  function cleanAudioText(s){ return clampStr(s).replace(/\s+/g, ' ').replace(/[•·]+/g, '. ').replace(/\s([;:!?])/g, '$1').trim(); }
  function collectTextFromNode(node){ if (!node) return ''; var clone = node.cloneNode(true); try{ var kill = clone.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn, script, style, [aria-hidden="true"]'); for (var i=0;i<kill.length;i++) if (kill[i] && kill[i].parentNode) kill[i].parentNode.removeChild(kill[i]); }catch(e){} return cleanAudioText(clone.textContent || ''); }
  function buildGeneralText(root){ var parts=[], slots=['title','kicker','h_def','def_short','def_long']; for (var i=0;i<slots.length;i++){ var el = root.querySelector('[data-po-slot="' + slots[i] + '"]'); var txt = collectTextFromNode(el); if (txt) parts.push(txt); } return cleanAudioText(parts.join('. ')); }
  function buildDetailText(detail){ if (!detail) return ''; var parts=[]; var title = detail.querySelector('.po-lex-summary__title'); var titleTxt = collectTextFromNode(title); if (titleTxt) parts.push(titleTxt); var bodyClone = detail.cloneNode(true); try{ var summary = bodyClone.querySelector('summary'); if (summary && summary.parentNode) summary.parentNode.removeChild(summary); var kill = bodyClone.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn, script, style'); for (var i=0;i<kill.length;i++) if (kill[i] && kill[i].parentNode) kill[i].parentNode.removeChild(kill[i]); }catch(e){} var bodyTxt = cleanAudioText(bodyClone.textContent || ''); if (bodyTxt) parts.push(bodyTxt); return cleanAudioText(parts.join('. ')); }
  function splitTextForSpeech(text, limit){ var maxLen = limit || 220; var raw = cleanAudioText(text); if (!raw) return []; var pieces = raw.match(/[^.!?;:…]+[.!?;:…]?/g) || [raw]; var out=[], current=''; for (var i=0;i<pieces.length;i++){ var piece = cleanAudioText(pieces[i]); if (!piece) continue; if (((current ? current + ' ' : '') + piece).length > maxLen){ if (current) out.push(current.trim()); if (piece.length > maxLen){ var words = piece.split(/\s+/), acc=''; for (var j=0;j<words.length;j++){ var w = words[j]; if (!w) continue; var next = acc ? (acc + ' ' + w) : w; if (next.length > maxLen){ if (acc) out.push(acc.trim()); acc = w; } else acc = next; } current = acc || ''; } else current = piece; } else current = current ? (current + ' ' + piece) : piece; } if (current) out.push(current.trim()); return out; }
  function pickSpeechVoice(lang){ if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== 'function') return null; var voices = PO_AUDIO_SYNTH.getVoices() || []; if (!voices.length) return null; var code = normLang(lang || getLang()) || 'fr'; var prefixes = code === 'fr' ? ['fr','fr-'] : (code === 'es' ? ['es','es-'] : ['en','en-']); for (var i=0;i<voices.length;i++){ var vLang = clampStr(voices[i].lang).toLowerCase(); if (!vLang) continue; for (var j=0;j<prefixes.length;j++) if (vLang === prefixes[j] || vLang.indexOf(prefixes[j]) === 0) return voices[i]; } return voices[0] || null; }
  function buildAudioUnits(root, startKey){ var units=[]; if (!root) return units; var details=root.querySelectorAll('.po-lex-details'); var startAt=0; var useGeneral=(startKey === 'general'); if (useGeneral){ var generalTxt=buildGeneralText(root); if (generalTxt) units.push({ key:'general', kind:'general', text:generalTxt, detail:null }); startAt=0; } else { var parsed=parseInt(String(startKey || '').replace(/^block-/, ''),10); startAt=isNaN(parsed)?0:parsed; } for (var i=startAt;i<details.length;i++){ var txt=buildDetailText(details[i]); if (txt) units.push({ key:'block-' + i, kind:'block', text:txt, detail:details[i] }); } return units; }
  function openDetailIfNeeded(unit){ if (!unit || unit.kind !== 'block' || !unit.detail) return; try{ unit.detail.open = true; }catch(e){} }
  function speakNextChunk(){ if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.speaking) return; PO_AUDIO_STATE.chunkPos += 1; if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){ PO_AUDIO_STATE.unitPos += 1; if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){ stopAudio(true); return; } var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos]; PO_AUDIO_STATE.activeKey = unit.key; PO_AUDIO_STATE.chunks = splitTextForSpeech(unit.text, 220); PO_AUDIO_STATE.chunkPos = -1; openDetailIfNeeded(unit); if (PO_AUDIO_STATE.root) updateAudioButtonsState(PO_AUDIO_STATE.root, getLang()); if (!PO_AUDIO_STATE.chunks.length){ speakNextChunk(); return; } speakNextChunk(); return; } var chunk = clampStr(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]); if (!chunk){ speakNextChunk(); return; } var utt; try{ utt = new SpeechSynthesisUtterance(chunk); }catch(e){ stopAudio(true); return; } var lang = getLang(); utt.lang = lang === 'fr' ? 'fr-FR' : (lang === 'es' ? 'es-ES' : 'en-US'); var voice = pickSpeechVoice(lang); if (voice) utt.voice = voice; utt.rate = 0.96; utt.pitch = 1; utt.volume = 1; utt.onend = function(){ PO_AUDIO_STATE.utterance = null; speakNextChunk(); }; utt.onerror = function(){ PO_AUDIO_STATE.utterance = null; speakNextChunk(); }; PO_AUDIO_STATE.utterance = utt; try{ PO_AUDIO_SYNTH.speak(utt); }catch(e){ stopAudio(true); } }
  function startAudio(root, startKey){ if (!PO_AUDIO_SYNTH || !root) return; var sameRoot=(PO_AUDIO_STATE.root===root), sameKey=(PO_AUDIO_STATE.activeKey===startKey); if (sameRoot && sameKey && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)){ stopAudio(true); return; } stopAudio(false); PO_AUDIO_STATE.root=root; PO_AUDIO_STATE.units=buildAudioUnits(root,startKey); PO_AUDIO_STATE.unitPos=-1; PO_AUDIO_STATE.chunks=[]; PO_AUDIO_STATE.chunkPos=-1; PO_AUDIO_STATE.activeKey=startKey; PO_AUDIO_STATE.speaking=true; updateAudioButtonsState(root,getLang()); speakNextChunk(); }
  function bindAudioButton(btn, root){ if (!btn || !root || btn.__poAudioBound) return; btn.addEventListener('click', function(ev){ if (ev && typeof ev.preventDefault==='function') ev.preventDefault(); if (ev && typeof ev.stopPropagation==='function') ev.stopPropagation(); if (!PO_AUDIO_SYNTH) return; var role=clampStr(btn.getAttribute('data-po-audio-role')||'block'); var idx=clampStr(btn.getAttribute('data-po-audio-index')||''); var key=(role==='general')?'general':('block-'+idx); startAudio(root,key); }); btn.__poAudioBound=true; }
  function ensureAudioButtons(root,lang){ if(!root) return; ensureAudioStyles(); var panel=root.querySelector('.po-lex-panel'); if(!panel) return; var generalWrap=root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]'); if(!generalWrap){ generalWrap=document.createElement('div'); generalWrap.className='po-axis-audio-wrap'; generalWrap.setAttribute('data-po-audio-role','general'); var generalBtn=createAudioButton('general'); generalWrap.appendChild(generalBtn); var meta=root.querySelector('.po-axis-meta'); var defShort=root.querySelector('[data-po-slot="def_short"]'); var firstDetail=panel.querySelector('.po-lex-details'); if(meta && meta.parentNode){ if(meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling); else meta.parentNode.appendChild(generalWrap);} else if(defShort && defShort.parentNode){ defShort.parentNode.insertBefore(generalWrap, defShort);} else if(firstDetail && firstDetail.parentNode){ firstDetail.parentNode.insertBefore(generalWrap, firstDetail);} else panel.appendChild(generalWrap);} var generalButton=generalWrap.querySelector('.po-axis-audio-btn[data-po-audio-role="general"]'); if(!generalButton){ generalButton=createAudioButton('general'); generalWrap.appendChild(generalButton);} bindAudioButton(generalButton,root); var details=root.querySelectorAll('.po-lex-details'); for(var i=0;i<details.length;i++){ details[i].setAttribute('data-po-audio-index',String(i)); var summary=details[i].querySelector('.po-lex-summary'); if(!summary) continue; var btn=summary.querySelector('.po-axis-audio-btn[data-po-audio-role="block"]'); if(!btn){ btn=createAudioButton('block',i); summary.appendChild(btn);} else btn.setAttribute('data-po-audio-index',String(i)); bindAudioButton(btn,root);} updateAudioButtonsState(root,lang||getLang()); }
  function initAudioEverywhere(lang){ var l=normLang(lang||getLang())||'fr'; var roots=getTargetBlocks(); for(var i=0;i<roots.length;i++) ensureAudioButtons(roots[i],l); }
  try{ if(PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.getVoices==='function'){ PO_AUDIO_SYNTH.onvoiceschanged=function(){ try{ initAudioEverywhere(getLang()); }catch(e){} }; } }catch(e){}

  var FALLBACK_FR = {
    title: CANON.title,
    kicker: 'Extrait du <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Isqun : bande de fréquences potentielles ; géométrie régulatrice à neuf faces ; fréquence harmonique 145)',
    cta_translate: 'Proposer une traduction du concept',
    h_def: 'Définition opérative',
    chips: ['Bande : Isqun', 'Rôle : régulation', 'Fréquence : 145'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ISQUN, IMG_FUNCTION, IMG_FREQ_145],
    def_short: 'Figure opérative de régulation à neuf faces : elle veille, redistribue, fait respirer.',
    def_long: 'L’Ennéagone régulateur désigne la configuration opérative qui apparaît lorsque les neuf Sceaux d’Isqun entrent dans une syntonie active complète. Il ne se confond pas avec Isqun : il en représente l’état dynamique de régulation conjointe, la géométrie-fonction par laquelle les intensités du champ sont tenues, redistribuées et rendues respirables.\n\nDans Katûpirsia 5, l’Ennéagone régulateur se déploie au sein d’Isqun, bande matricielle à neuf pôles issue et traversée par La Katûvýs. Chaque Sceau agit comme nœud de désaturation et de réajustement ; leur interaction simultanée fait apparaître cette forme globale de tenue. L’Ennéagone régulateur veille donc à la circulation des excès sans les dissoudre, maintient l’Organon praticable, et rend sensible une cohérence de champ à la fois stable et mobile.\n\nLe corpus souligne aussi sa différence avec Threnisqun : l’Ennéagone régulateur tient le plan continu, silencieux et global de la régulation ; Threnisqun répond dans le particulier, sous forme d’émanations et d’activations localisées. La fréquence harmonique 145 signe cette figure comme nombre-guide propre, tandis que l’onde d’alignement 492 demeure celle d’Isqun et de Threnisqun.',
    h_features: 'Déploiement',
    h_questions: 'Tests d’usage',
    hint_fold: 'déplier',
    hint_fold2: 'déplier',
    hint_fold3: 'déplier',
    example_title: 'Exemple opératif',
    example: 'J’active l’Ennéagone régulateur pour veiller la tenue du champ, redistribuer l’excédent, et rendre la régulation respirable dans l’accord.',
    features: [
      'Veiller : maintenir l’accord général quand l’intensité du champ augmente, éviter le débordement.',
      'Redistribuer : orienter l’excédent vers les canaux pertinents sans dissoudre la signature des forces.',
      'Faire respirer : rendre la régulation sensible sous forme de pulsation, cadence, reprise.',
      'Régulateur à neuf faces : chaque face correspond à une fonction de tenue, un seuil, une reprise.',
      'Pont pratique : rendre la structure lisible, activable, transmissible dans les Méditations et les Accords.'
    ],
    questions: [
      'Quand une circulation s’emballe et demande cadence : « Ennéagone régulateur ».',
      'Quand neuf fonctions doivent coexister sans se parasiter : « Ennéagone régulateur ».',
      'Quand un protocole a besoin d’un régulateur simple, clair, transmissible : « j’active l’Ennéagone régulateur ».',
      'Quand il faut distinguer le plan qui veille du plan qui répond : « Isqun tient, Threnisqun répond, l’Ennéagone régulateur accorde ». '
    ],
    h_family: 'Position & relations',
    family_1: '<p><strong>Position systémique :</strong> l’Ennéagone régulateur appartient à <strong>l’Isqun</strong>, bande de fréquences potentielles à neuf pôles. K5 précise qu’il ne se confond pas avec cette bande : il en est la <strong>configuration opérative</strong>, l’état dynamique qui apparaît lorsque les neuf Sceaux vibrent conjointement dans une cohérence simultanée.</p>',
    family_2: '<p><strong>Relation interne :</strong> l’Ennéagone régulateur tient le plan global, continu et silencieux de la régulation ; <strong>Threnisqun</strong> répond dans le local, le situé, le rituélique. Son rôle consiste à veiller, redistribuer et faire respirer l’ensemble, afin que les intensités restent praticables sans rupture de champ.</p>',
    h_wordbuild: 'Formation du nom & place canonique',
    word_blocks: [
      { head: 'Ennéa-', text: 'Neuf : nombre de faces, de pôles et de fonctions ; principe de partition opérative dans Isqun.' },
      { head: '-gone', text: 'Angle / figure : forme tenue, lisible, activable ; géométrie devenue fonction régulatrice.' },
      { head: 'Ennéagone régulateur', text: 'Le nom canonique développé du corpus désigne la figure opérative globale des neuf Sceaux d’Isqun ; il ne s’agit ni d’un simple motif géométrique ni d’un décor symbolique.' },
      { head: '145 / 492', text: '145 est la fréquence harmonique propre de l’Ennéagone régulateur. 492 demeure l’onde d’alignement commune d’Isqun et de Threnisqun, c’est-à-dire le plan d’accord externe du champ régulatoire.' }
    ],
    word_notes: [
      'Le titre reste en FR : Ennéagone régulateur.',
      'Isqun fonde l’Ennéagone régulateur ; Threnisqun en reçoit les émanations sous forme d’entités activables.',
      'La figure sert de matrice de tenue, de lecture et de réglage : elle n’a rien de décoratif.'
    ]
  };

  var FALLBACK_EN = {
    title: CANON.title,
    kicker: 'Excerpt from <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Isqun: band of potential frequencies; nine-faced regulating geometry; harmonic frequency 145)',
    cta_translate: 'Propose a translation of the concept',
    h_def: 'Operative definition',
    chips: ['Band: Isqun', 'Role: regulation', 'Frequency: 145'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ISQUN, IMG_FUNCTION, IMG_FREQ_145],
    def_short: 'Nine-faced operative regulator: it watches, redistributes, makes the field breathe.',
    def_long: 'Ennéagone régulateur names the operative configuration that appears when the nine Seals of Isqun enter complete active syntony. It is not identical with Isqun: it is the dynamic state of joint regulation, the geometry-function through which intensities are held, redistributed and made breathable.\n\nIn Katûpirsia 5, Ennéagone régulateur unfolds within Isqun, the nine-poled matrix-band issued from and traversed by La Katûvýs. Each Seal acts as a node of desaturation and readjustment; their simultaneous interaction makes this global form of holding appear. Ennéagone régulateur watches over circulation without dissolving excess, keeps the Organon practicable, and renders field-coherence sensible as both stable and mobile.\n\nThe corpus also distinguishes it from Threnisqun: Ennéagone régulateur holds the continuous, silent and global plane of regulation; Threnisqun responds in the particular, as emanations and localized activations. Harmonic frequency 145 signs the figure itself, while 492 remains the common alignment-wave of Isqun and Threnisqun.',
    h_features: 'Unfolding',
    h_questions: 'Use tests',
    hint_fold: 'expand',
    hint_fold2: 'expand',
    hint_fold3: 'expand',
    example_title: 'Operative example',
    example: 'I activate Ennéagone régulateur to watch over the field, redistribute the surplus, and make regulation breathable within the accord.',
    features: [
      'To watch: keep the overall tuning when field intensity rises, preventing overflow.',
      'To redistribute: route the surplus to relevant channels without dissolving signatures.',
      'To make breathe: render regulation as pulse, cadence and return.',
      'Nine-faced regulator: each face corresponds to a holding function, a threshold, a reprise.',
      'Practical bridge: make the structure readable, activable and transmissible in Meditations and Accords.'
    ],
    questions: [
      'When a circulation accelerates and needs cadence: “Ennéagone régulateur.”',
      'When nine functions must co-exist without interference: “Ennéagone régulateur.”',
      'When a protocol needs a simple, clear and transmissible regulator: “I activate Ennéagone régulateur.”',
      'When the plane that watches must be distinguished from the plane that responds: “Isqun holds, Threnisqun answers, Ennéagone régulateur tunes.”'
    ],
    h_family: 'Position & relations',
    family_1: '<p><strong>Systemic position:</strong> Ennéagone régulateur belongs to <strong>Isqun</strong>, the nine-poled band of potential frequencies. K5 specifies that it is not identical with this band: it is its <strong>operative configuration</strong>, the dynamic state that appears when the nine Seals vibrate in simultaneous coherence.</p>',
    family_2: '<p><strong>Internal relation:</strong> Ennéagone régulateur holds the global, continuous and silent plane of regulation; <strong>Threnisqun</strong> responds in the local, situated, ritual plane. Its role is to watch, redistribute and make the whole breathe so intensities remain practicable without rupture.</p>',
    h_wordbuild: 'Name formation & canonical place',
    word_blocks: [
      { head: 'Ennéa-', text: 'Nine: number of faces, poles and functions; principle of operative partition within Isqun.' },
      { head: '-gone', text: 'Angle / figure: held, readable, activable form; geometry turned into regulating function.' },
      { head: 'Ennéagone régulateur', text: 'The developed canonical name designates the global operative figure of the nine Seals of Isqun; it is neither a decorative geometry nor a mere symbol.' },
      { head: '145 / 492', text: '145 is the harmonic frequency proper to Ennéagone régulateur. 492 remains the common alignment-wave of Isqun and Threnisqun, the external accord-plane of the regulatory field.' }
    ],
    word_notes: [
      'The title remains FR: Ennéagone régulateur.',
      'Isqun grounds Ennéagone régulateur; Threnisqun receives its emanations as activable entities.',
      'The figure serves as a matrix of holding, reading and tuning; it is never decorative.'
    ]
  };

  var FALLBACK_ES = {
    title: CANON.title,
    kicker: 'Extracto de <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Isqun: banda de frecuencias potenciales; geometría reguladora de nueve caras; frecuencia armónica 145)',
    cta_translate: 'Proponer una traducción del concepto',
    h_def: 'Definición operativa',
    chips: ['Banda: Isqun', 'Rol: regulación', 'Frecuencia: 145'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ISQUN, IMG_FUNCTION, IMG_FREQ_145],
    def_short: 'Regulador operativo de nueve caras: vigila, redistribuye, hace respirar el campo.',
    def_long: 'Ennéagone régulateur nombra la configuración operativa que aparece cuando los nueve Sellos de Isqun entran en una sintonía activa completa. No se confunde con Isqun: representa su estado dinámico de regulación conjunta, la geometría-función por la cual las intensidades son sostenidas, redistribuidas y vueltas respirables.\n\nEn Katûpirsia 5, Ennéagone régulateur se despliega dentro de Isqun, banda matricial de nueve polos emanada de y atravesada por La Katûvýs. Cada Sello actúa como nudo de desaturación y reajuste; su interacción simultánea hace aparecer esta forma global de sostén. Ennéagone régulateur vela la circulación sin disolver el exceso, mantiene el Organon practicable y vuelve sensible una coherencia de campo a la vez estable y móvil.\n\nEl corpus también lo distingue de Threnisqun: Ennéagone régulateur sostiene el plano continuo, silencioso y global de la regulación; Threnisqun responde en lo particular, mediante emanaciones y activaciones localizadas. La frecuencia armónica 145 firma la figura, mientras 492 sigue siendo la onda común de alineación de Isqun y Threnisqun.',
    h_features: 'Despliegue',
    h_questions: 'Pruebas de uso',
    hint_fold: 'desplegar',
    hint_fold2: 'desplegar',
    hint_fold3: 'desplegar',
    example_title: 'Ejemplo operativo',
    example: 'Activo Ennéagone régulateur para velar la tenida del campo, redistribuir el excedente y volver respirable la regulación dentro del acuerdo.',
    features: [
      'Vigilar: mantener el ajuste general cuando aumenta la intensidad del campo, evitando el desborde.',
      'Redistribuir: orientar el excedente hacia los canales pertinentes sin disolver las firmas.',
      'Hacer respirar: volver sensible la regulación como pulso, cadencia y retorno.',
      'Regulador de nueve caras: cada cara corresponde a una función de sostén, un umbral, una reprise.',
      'Puente práctico: volver la estructura legible, activable y transmisible en Meditaciones y Acuerdos.'
    ],
    questions: [
      'Cuando una circulación se acelera y pide cadencia: « Ennéagone régulateur ».',
      'Cuando nueve funciones deben coexistir sin interferencias: « Ennéagone régulateur ».',
      'Cuando un protocolo necesita un regulador simple, claro y transmisible: « activo Ennéagone régulateur ».',
      'Cuando hay que distinguir el plano que vela del plano que responde: « Isqun sostiene, Threnisqun responde, Ennéagone régulateur ajusta ». '
    ],
    h_family: 'Posición y relaciones',
    family_1: '<p><strong>Posición sistémica:</strong> Ennéagone régulateur pertenece a <strong>Isqun</strong>, banda de frecuencias potenciales de nueve polos. K5 precisa que no es idéntico a esa banda: constituye su <strong>configuración operativa</strong>, el estado dinámico que aparece cuando los nueve Sellos vibran en coherencia simultánea.</p>',
    family_2: '<p><strong>Relación interna:</strong> Ennéagone régulateur sostiene el plano global, continuo y silencioso de la regulación; <strong>Threnisqun</strong> responde en el plano local, situado y ritual. Su función consiste en vigilar, redistribuir y hacer respirar el conjunto para que las intensidades sigan siendo practicables sin ruptura.</p>',
    h_wordbuild: 'Formación del nombre y lugar canónico',
    word_blocks: [
      { head: 'Ennéa-', text: 'Nueve: número de caras, polos y funciones; principio de partición operativa dentro de Isqun.' },
      { head: '-gone', text: 'Ángulo / figura: forma sostenida, legible y activable; geometría convertida en función reguladora.' },
      { head: 'Ennéagone régulateur', text: 'El nombre canónico desarrollado designa la figura operativa global de los nueve Sellos de Isqun; no es ni una geometría decorativa ni un simple símbolo.' },
      { head: '145 / 492', text: '145 es la frecuencia armónica propia de Ennéagone régulateur. 492 sigue siendo la onda de alineación común de Isqun y Threnisqun, es decir, el plano externo de acuerdo del campo regulador.' }
    ],
    word_notes: [
      'El título permanece en FR: Ennéagone régulateur.',
      'Isqun funda Ennéagone régulateur; Threnisqun recibe sus emanaciones como entidades activables.',
      'La figura sirve como matriz de sostén, lectura y ajuste; nunca es decorativa.'
    ]
  };

  function getFallback(lang){ var l = normLang(lang) || 'fr'; if (l === 'en') return FALLBACK_EN; if (l === 'es') return FALLBACK_ES; return FALLBACK_FR; }
  function getAxisLexId(node){ try{ return node.getAttribute('data-po-lex-id') || ''; }catch(e){ return ''; } }
  function lockNode(el){ if (!el || !el.setAttribute) return; try{ el.setAttribute('translate','no'); }catch(e){} try{ if (el.classList){ el.classList.add('notranslate'); el.classList.add('po-lex-slotlock'); } }catch(e){} }
  function firstNonEmpty(){ for (var i=0;i<arguments.length;i++){ var v=arguments[i]; if (Array.isArray(v)){ if (v.length) return v; } else if (clampStr(v)) return v; } return Array.isArray(arguments[0]) ? [] : ''; }

  function getAxisData(node, lang){
    var l = normLang(lang) || 'fr';
    var base = getFallback(l);
    var out = {};
    for (var k in base) out[k] = base[k];
    var lexId = getAxisLexId(node);
    var entry = lexId ? getLexiconEntry(lexId) : null;
    out.title = CANON.title;
    if (entry){
      out.kicker = firstNonEmpty(pickAny(entry,'kicker_' + l,''), pickAny(entry,'kicker_fr',''), pickAny(entry,'kicker',''), out.kicker);
      if (l === 'fr'){
        out.def_short = firstNonEmpty(pickDefShort(entry,'fr'), out.def_short);
        out.def_long = firstNonEmpty(pickDefLong(entry,'fr'), out.def_long);
        out.features = firstNonEmpty(pickArray(entry,'fr','features'), pickArray(entry,'fr','characteristics'), out.features);
        out.questions = firstNonEmpty(pickArray(entry,'fr','questions'), pickArray(entry,'fr','usage_questions'), out.questions);
      }
    }
    out.title = CANON.title;
    out.title_img = base.title_img || IMG_IDEOGRAM_CONCEPT;
    out.chip_urls = base.chip_urls || [IMG_ISQUN, IMG_FUNCTION, IMG_FREQ_145];
    return out;
  }

  function qs(root, sel){ try{ return root.querySelector(sel); }catch(e){ return null; } }
  function setSlotText(root, slot, txt){ var el = qs(root, '[data-po-slot="' + slot + '"]'); if (!el) return; lockNode(el); el.textContent = clampStr(txt); }
  function setSlotHTML(root, slot, html){ var el = qs(root, '[data-po-slot="' + slot + '"]'); if (!el) return; lockNode(el); el.innerHTML = protectKeywordsHTML(clampStr(html)); protectKeywordsInElement(el); }
  function setSlotImg(root, slot, src, alt){ var el = qs(root, '[data-po-slot="' + slot + '"]'); if (!el) return; var s = clampStr(src), a = clampStr(alt); if (!s){ try{ el.removeAttribute('src'); }catch(e){} try{ el.setAttribute('alt',''); }catch(e){} try{ el.style.display='none'; }catch(e){} return; } try{ el.setAttribute('src',s); }catch(e){} try{ el.setAttribute('alt',a); }catch(e){} try{ el.style.display=''; }catch(e){} }
  function setSlotImgSrc(root, slot, src, alt){ setSlotImg(root, slot, src, alt); }
  function renderList(root, slot, items){ var el = qs(root, '[data-po-slot="' + slot + '"]'); if (!el) return; lockNode(el); var arr = Array.isArray(items) ? items : []; var out=[]; for (var i=0;i<arr.length;i++) out.push('<li>' + protectKeywordsHTML(clampStr(arr[i])) + '</li>'); el.innerHTML = out.join(''); protectKeywordsInElement(el); }
  function renderExampleBox(root, slot, exampleTitle, exampleText){ var el = qs(root, '[data-po-slot="' + slot + '"]'); if (!el) return; lockNode(el); var t = clampStr(exampleTitle), x = clampStr(exampleText); if (!t && !x){ el.innerHTML=''; return; } el.innerHTML = '<div class="po-lex-example__title"><strong>' + protectKeywordsHTML(t) + '</strong></div><div class="po-lex-example__text">' + protectKeywordsHTML(x) + '</div>'; protectKeywordsInElement(el); }
  function renderWordBlocks(root, slot, blocks){ var el = qs(root, '[data-po-slot="' + slot + '"]'); if (!el) return; lockNode(el); var arr = Array.isArray(blocks)?blocks:[]; var out=[]; for (var i=0;i<arr.length;i++){ var b=arr[i]||{}; out.push('<div class="po-axis-wb"><div class="po-axis-wb__h">' + protectKeywordsHTML(clampStr(b.head)) + '</div><div class="po-axis-wb__t">' + protectKeywordsHTML(clampStr(b.text)) + '</div></div>'); } el.innerHTML=out.join(''); protectKeywordsInElement(el); }

  function applyToAxis(node, lang){
    var data = getAxisData(node, lang);
    var chipUrls = Array.isArray(data.chip_urls) ? data.chip_urls : [IMG_ISQUN, IMG_FUNCTION, IMG_FREQ_145];
    setSlotImgSrc(node, 'title_img', data.title_img || IMG_IDEOGRAM_CONCEPT, data.title || CANON.title);
    setSlotText(node, 'title', data.title || CANON.title);
    setSlotHTML(node, 'kicker', data.kicker || '');
    setSlotText(node, 'h_def', data.h_def || '');
    var chips = Array.isArray(data.chips) ? data.chips : [];
    setSlotText(node, 'chip_1', chips[0] || '');
    setSlotText(node, 'chip_2', chips[1] || '');
    setSlotText(node, 'chip_3', chips[2] || '');
    setSlotImgSrc(node, 'chip_1_img', chipUrls[0] || IMG_ISQUN, chips[0] || '');
    setSlotImgSrc(node, 'chip_2_img', chipUrls[1] || IMG_FUNCTION, chips[1] || '');
    setSlotImgSrc(node, 'chip_3_img', chipUrls[2] || IMG_FREQ_145, chips[2] || '');
    setSlotHTML(node, 'def_short', htmlParagraphize(data.def_short || ''));
    setSlotHTML(node, 'def_long', htmlParagraphize(data.def_long || ''));
    setSlotText(node, 'h_features', data.h_features || '');
    setSlotText(node, 'hint_fold', data.hint_fold || '');
    renderList(node, 'features', data.features || []);
    setSlotText(node, 'h_questions', data.h_questions || '');
    setSlotText(node, 'hint_fold2', data.hint_fold2 || data.hint_fold || '');
    renderList(node, 'questions', data.questions || []);
    renderExampleBox(node, 'example_box', data.example_title || '', data.example || '');
    setSlotText(node, 'h_family', data.h_family || '');
    setSlotText(node, 'hint_fold3', data.hint_fold3 || data.hint_fold || '');
    setSlotHTML(node, 'family_1', data.family_1 || '');
    setSlotHTML(node, 'family_2', data.family_2 || '');
    setSlotText(node, 'h_wordbuild', data.h_wordbuild || '');
    renderWordBlocks(node, 'wordbuild_blocks', data.word_blocks || []);
    renderList(node, 'wordbuild_notes', data.word_notes || []);
    setSlotText(node, 'cta_translate', data.cta_translate || '');
  }

  function hasLexiconReady(){
    try{ if (window.PO_LEXICON_MAP) return true; if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true; if (window.PO_LEXICON_META && window.PO_LEXICON_META.lexique_simplifie_fr) return true; }catch(e){}
    return false;
  }

  function bindLangButtons(root){
    if (!root) return;
    var bar = qs(root, '[data-po-langbar]');
    if (!bar || bar.__poLangBound) return;
    bar.addEventListener('click', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-po-lang]') : null;
      if (!btn) return;
      ev.preventDefault();
      var l = normLang(btn.getAttribute('data-po-lang')) || 'fr';
      applyLangEverywhere(l);
    });
    bar.__poLangBound = true;
  }

  function syncLangButtons(root, lang){
    if (!root) return;
    var btns = root.querySelectorAll('[data-po-langbar] [data-po-lang]');
    for (var i=0;i<btns.length;i++){
      var bl = normLang(btns[i].getAttribute('data-po-lang')) || 'fr';
      try{ btns[i].setAttribute('aria-pressed', bl === lang ? 'true' : 'false'); }catch(e){}
    }
  }

  function applyLangEverywhere(lang){
    var l = normLang(lang) || getLang() || 'fr';
    storeLang(l);
    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++){
      bindLangButtons(roots[i]);
      applyToAxis(roots[i], l);
      syncLangButtons(roots[i], l);
    }
    initAudioEverywhere(l);
    notifyLocaleChanged();
    return l;
  }

  var __PO_ENNEAGONE_LISTENERS_SET__ = false;
  var __PO_ENNEAGONE_OBSERVER__ = null;

  function init(){
    if (!readStoredLang()) storeLang(detectBrowserLang());
    applyLangEverywhere(getLang());

    if (!__PO_ENNEAGONE_LISTENERS_SET__){
      __PO_ENNEAGONE_LISTENERS_SET__ = true;
      window.addEventListener('po:lexicon-ready', function(){ __PO_PROTECT_CACHE__.key=''; __PO_PROTECT_CACHE__.re=null; applyLangEverywhere(getLang()); });
      try{
        if (document && document.documentElement && !__PO_ENNEAGONE_OBSERVER__){
          __PO_ENNEAGONE_OBSERVER__ = new MutationObserver(function(muts){
            if (__PO_HTML_LANG_SYNC__) return;
            for (var i=0;i<muts.length;i++){
              if (muts[i].type === 'attributes' && muts[i].attributeName === 'lang'){
                applyLangEverywhere(getLang());
                break;
              }
            }
          });
          __PO_ENNEAGONE_OBSERVER__.observe(document.documentElement, { attributes:true });
        }
      }catch(e){}
    }

    if (!hasLexiconReady()){
      var tries = 0, maxTries = 24;
      var it = setInterval(function(){
        tries++;
        if (hasLexiconReady() || tries >= maxTries){
          clearInterval(it);
          __PO_PROTECT_CACHE__.key='';
          __PO_PROTECT_CACHE__.re=null;
          applyLangEverywhere(getLang());
        }
      }, 250);
    }
  }

  window.PoKatupirsia5EnneagoneTextsFR_EN_ES_20260303 = {
    init: init,
    getLang: getLang,
    normLang: normLang,
    setLang: function(raw){ var l = normLang(raw) || 'fr'; return applyLangEverywhere(l); },
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.init = init;
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = function(lang){ return window.PoKatupirsia5EnneagoneTextsFR_EN_ES_20260303.setLang(lang); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
